import type {Gsoa_ProductCatalog_Ribbon as GsoaRibbon} from '~/openapi';

export type BadgePosition = 'bottom-left' | 'top-right' | 'bottom-right';

export enum Badge {
	CZ_PRODUCT = 'vCZProduct',
	AGE_LIMIT = 'vAgeLimit',
	SECURITY_TAG = 'vSecurityTag',
	MORE_VARIANTS = 'vMoreVariants',
}

export enum Ribbon {
	MIMICLUB = 'vMimiclub',
	COUPON = 'vCoupon',
	CASHBACK = 'vCashback',
	vVVGButchery = 'vVVGButchery',
	vVVGBakery = 'vVVGBakery',
	vVVGRestaurant = 'vVVGRestaurant',
	vHelp = 'vHelp',
}

export type RibbonData = GsoaRibbon & {
	type: Ribbon;
};

export type RenderableItem = {
	ribbon: RibbonData;
	vHelpPrice?: number;
};

export enum NutritionValues {
	atr_czr_proteins_os = 'Bílkoviny',
	atr_czr_sugars_os = 'Cukry',
	atr_czr_energy_kcal_os = 'Energie v kcal',
	atr_czr_energy_kj_os = 'Energie v kJ',
	atr_czr_portion_unit = 'Jednotka porce',
	atr_czr_monounsaturated_fatty_acids_os = 'Mononenasycené mastné kyseliny',
	atr_czr_saturated_fatty_acids_os = 'Nasycené mastné kyseliny',
	atr_czr_polyalcohols_os = 'Polyalkoholy',
	atr_czr_polyunsaturated_fatty_acids_os = 'Polynenasycené mastné kyseliny',
	atr_czr_carbohydrates_os = 'Sacharidy',
	atr_czr_salt_os = 'Sůl',
	atr_czr_starches_os = 'Škroby',
	atr_czr_fats_os = 'Tuky',
	atr_czr_fiber_os = 'Vláknina',
	atr_czr_alcohol_percentage = 'Obsah alkoholu',
}
